import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

// Mirrors BenchReport's FiltersBar: bare controls in a flex row with a
// bottom divider, no card/box wrapping.
export const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 24px;
`;

export const FilterLabel = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${COLORS.SECONDARY};
  margin-right: 4px;
`;

export const TableWrapper = styled.div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
`;

export const SummaryTile = styled.div`
  background: white;
  border-radius: 8px;
  padding: 16px 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SummaryLabel = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${COLORS.SECONDARY};
`;

export const SummaryValue = styled.div`
  font-size: 22px;
  font-weight: 600;
  color: ${COLORS.PRIMARY};
`;

export const SummaryMeta = styled.div`
  font-size: 12px;
  color: ${COLORS.SECONDARY};
`;

// The app's Load More button is the Bench Candidates one (owner, 2026-10-09):
// re-exported so this report, Ingestion Sync Runs (which borrows these styles)
// and the ADR-165/166 reports all render the same button.
export { LoadMoreButton } from '../BenchCandidates/styles';

export const TwoLine = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const TwoLinePrimary = styled.span`
  font-weight: 500;
`;

export const TwoLineSecondary = styled.span`
  font-size: 12px;
  color: ${COLORS.SECONDARY};
`;

// Matches the row-hover style used in BenchReport (EmployeeRow):
// soft slate background with a short transition.
export const RunRow = styled.tr`
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover {
    background-color: #f8fafc;
  }
`;
